module.exports = __webpack_public_path__ + "img/avatar.959fd2e9.png";